import { cn } from "cn";
import type { ReactNode } from "react";

type PresaleSectionProps = {
  id?: string;
  title: string;
  children: ReactNode;
  className?: string;
};

export function PresaleSection({
  id,
  title,
  children,
  className,
}: PresaleSectionProps) {
  return (
    <section
      id={id}
      className={cn("mt-14 border-t border-border-dark-low pt-10", className)}
    >
      <h2 className="text-2xl font-semibold text-text-dark-max">{title}</h2>
      {children}
    </section>
  );
}
